import { gql } from '@apollo/client'

export const AddressFragment = gql`
    fragment addressFragment on Address {
        city
        country
        postalCode
        region
        street1
        street2
    }
`
